import { PillBaja } from './i18n'

// Colores de las pills CONV/JUG/TIT/LES/SAN/ENF/VAC/TR/NJ de la fila de cada jornada — movido aquí
// (antes vivía solo dentro de `MinutajeTab.tsx`) para que el panel de estadísticas por jugador
// pueda usar exactamente los mismos colores (feedback del cliente, 2026-10-06: "mejor... usar
// colores como en el detalle de la fila. Por ejemplo Convocados verde como arriba, titulares
// morado y así el resto").
export const PILL_COLOR: Record<'conv' | 'jug' | 'tit' | PillBaja, string> = {
  conv: 'var(--color-pill-conv)',
  jug: 'var(--color-pill-jug)',
  tit: 'var(--color-pill-tit)',
  LES: 'var(--color-pill-les)',
  SAN: 'var(--color-pill-san)',
  ENF: 'var(--color-pill-enf)',
  VAC: 'var(--color-pill-vac)',
  TR: 'var(--color-pill-tr)',
  NJ: 'var(--color-pill-nj)',
}
